<!-- 
Listing of sandboxes. Also allows creation, deletion and opening of sandboxes.
-->
<template>
  <div>
    <v-card class="v-card--flat">
      <our-table-busy-indicator :show="busy"/>
      <v-data-table 
        :headers="headers" 
        :items="listing" 
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr class="noselect">
            <our-nav-col :row="`${props.item.year} ${props.item.type}`"/>
            <td>{{ props.item.year }}</td>
            <td>{{ lookups.levyCollectionTypeDescriptions[props.item.type] }}</td>
            <td class="text-xs-right">
              <v-btn
                :disabled="busy || !isSandbox(props.item)"
                flat color="primary"
                @click="open(props.item.id)"
              >
                Open
              </v-btn>
              <v-btn 
                v-if="canEdit"
                :disabled="busy || isSandbox(props.item)" 
                flat color="primary" 
                @click="create(props.item.id)"
              >
                Create sandbox
              </v-btn>
              <v-btn 
                v-if="canEdit"
                :disabled="busy || !isSandbox(props.item)" 
                flat color="error" 
                @click="deleteSandbox(props.item.id)"
              >
                Delete
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import _ from "underscore";
import * as claim from "@/store/claim-types";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/sandboxes/action-types";

export default {
  mixins: [lookupMixins],
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Year", value: "Year", sortable: false, width: 100 },
        { text: "Type", value: "Type", sortable: false },
        { text: "", value: "Actions", sortable: false }
      ]
    };
  },
  computed: {
    state() {
      return this.$store.state.sandboxes.create;
    },
    busy() {
      return this.state.saving || this.$store.state.sandboxes.delete.processing;
    },
    listing() {
      return _(this.lookups.allLevyCollections).filter(c => !c.hasSandbox);
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.LEVY_COLLECTION_SANDBOXES);
    }
  },
  methods: {
    create(levyCollectionId) {
      this.$store.dispatch(action.CREATE, levyCollectionId);
    },
    open(levyCollectionId) {
      this.$router.push(`/levy-collections/${levyCollectionId}/sandbox`);
    },
    isSandbox(levyCollection) {
      return this.doesLookupHaveAttribute(levyCollection.type, "IsSandbox", this.lookups.levyCollectionTypes);
    },
    deleteSandbox(levyCollectionId) {
      this.$store.dispatch(action.DELETE, levyCollectionId);
    }
  }
};
</script>
